module.exports = __webpack_public_path__ + "img/card-8.81d89f49.png";